export function ShowCard() {
    return {
        type: 'SHOWCARD'
    }
}

export function HideCard() {
    return {
        type: 'HIDECARD'
    }
}


// WEBPACK FOOTER //
// ./src/src/actions.js